import { Percent } from '@kodiak-finance/sdk-core'

export const DEFAULT_AUTO_SLIPPAGE = new Percent(30, 10_000)
